/**
 * Created by h3 on 2018-01-18.
 */

export class TeslaStrings {
    public static FS_INTRO_TEXT:string = "Charged Wilds on reel 2, 3, 4. Time-lapse trigger on reel 5.";
    public static FS_YOU_WON_TEXT:string = "You won";

    public static TEXT_CLOSE:string = "Closes in";
    public static TEXT_SECONDS:string = "seconds";
    public static TEXT_SECOND:string = "second";
}